/**
 * DiagnosticsService - Service for Data Quality Analysis
 * 
 * SOLID Principles: Single Responsibility Principle (SRP) & Dependency Inversion Principle (DIP)
 * Purpose: Provides data quality analysis and diagnostics functionality,
 * abstracting the implementation details from components.
 * 
 * Responsibilities:
 * - Process raw data for quality issues
 * - Generate flagged row diagnostics
 * - Provide consistent interface for diagnostics operations
 * - Abstract diagnostics implementation from UI components
 */

import { getDiagnostics } from '../../../../utils/diagnostics';

export class DiagnosticsService {
  /**
   * Analyze raw data for quality issues
   * @param {Array} rawData - Raw sensor data to analyze
   * @returns {Array} Array of flagged data points
   */
  static analyzeFlaggedRows(rawData) {
    return getDiagnostics(rawData);
  }

  /**
   * Get flagged rows for a specific buoy
   * @param {Array} flaggedRows - All flagged data points
   * @param {string} buoyId - Buoy ID to filter by
   * @returns {Array} Flagged rows for the specified buoy
   */
  static getFlaggedRowsForBuoy(flaggedRows, buoyId) {
    return flaggedRows.filter(d => (d.buoy_id || d.buoyId) === buoyId);
  }

  /**
   * Check if data point is flagged
   * @param {Object} dataPoint - Data point to check
   * @param {Array} flaggedRows - Array of flagged data points
   * @returns {boolean} True if data point is flagged
   */
  static isDataPointFlagged(dataPoint, flaggedRows) {
    return flaggedRows.some(flagged => 
      flagged._time === dataPoint._time && 
      (flagged.buoy_id || flagged.buoyId) === (dataPoint.buoy_id || dataPoint.buoyId)
    );
  }
}

export default DiagnosticsService;